export interface FileMetadata {
  contentLength: number;
  contentType: string;
}

/**
 * MMS size limit in decimal kilobytes for consistent backend processing
 *
 * Kilobyte (1000), not kibibyte (1024)
 */
export const MMS_SIZE_LIMIT_KB = 500;

/**
 * Recommended longest side dimension for MMS images to optimize compression while maintaining quality
 */
export const MMS_RECOMMENDED_LONGEST_SIDE_PX = 1000;

/**
 * MMS carrier limit: 500KB in decimal kilobytes (500,000 bytes) for optimal delivery
 *
 * @see {@link https://help.twilio.com/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada#h_01F65Y53DBJAFF6WJ19NXQFN3V | Twilio MMS best practices}
 * @see {@link https://developers.telnyx.com/docs/messaging/messages/mms-transcoding | Telnyx MMS transcoding}
 * @see {@link https://support.bandwidth.com/hc/en-us/articles/360014235473-What-are-the-MMS-file-size-limits#:~:text=we%20recommend%20sending%20attachments%20no%20larger%20than%20500%20KB%20to%20ensure%20the%20best%20chance%20of%20delivery. | Bandwidth MMS file size limits}
 */
export const MAX_TOTAL_ATTACHMENT_SIZE_BYTES = MMS_SIZE_LIMIT_KB * 1000;

export function canFileBeSentViaMMS(mimeType: string): boolean {
  return VALID_MMS_MIME_TYPES.includes(mimeType);
}
const VALID_MMS_MIME_TYPES = [
  "text/plain",
  "text/vcard",
  "image/jpeg",
  "image/png",
  "image/gif",
  "video/3gpp",
  "video/mp4",
];

export enum MMSRejectReason {
  SIZE_EXCEEDED = "size_exceeded",
  INVALID_TYPE = "invalid_type",
}
